import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { FormControl, FormControlLabel } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Typography, RaiseColors } from "componentLibrary";
import { Checkbox } from "client/componentLibrary";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    formControl: {
      display: "flex",
      flexDirection: "column",
      overflowY: "auto",
      height: "100%",
      maxHeight: "400px",
      gap: "8px"
    }
  };
});
var CheckboxFilterGroup = function CheckboxFilterGroup(_ref) {
  var filterName = _ref.filterName,
    subtitle = _ref.subtitle,
    checkboxGroupElements = _ref.checkboxGroupElements,
    onChange = _ref.onChange,
    _ref$actionButtons = _ref.actionButtons,
    actionButtons = _ref$actionButtons === void 0 ? [] : _ref$actionButtons,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var classes = useStyles();
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      height: "100%"
    },
    children: [subtitle && /*#__PURE__*/_jsx(Typography, {
      style: {
        margin: "8px 0px"
      },
      color: RaiseColors.grayscale900,
      weight: "semibold",
      variant: "overline_small",
      children: subtitle
    }), /*#__PURE__*/_jsx(FormControl, {
      className: classes.formControl,
      variant: "standard",
      children: /*#__PURE__*/_jsx(CheckBoxGroup, {
        checkboxGroupElements: checkboxGroupElements,
        filterName: filterName,
        onChange: onChange,
        actionButtons: actionButtons,
        disabled: disabled
      })
    })]
  });
};
export default CheckboxFilterGroup;
var checkboxStyles = makeStyles(function (theme) {
  return {
    checkbox: {
      border: "none",
      padding: "0px"
    },
    formControlLabel: {
      margin: "8px",
      width: "100%"
    },
    formControlLabelActionButtons: {
      margin: "8px",
      width: "100%",
      "& .MuiFormControlLabel-label": {
        width: "100%"
      }
    },
    labelContainer: {
      borderRadius: "8px",
      display: "flex",
      "&:hover": {
        backgroundColor: RaiseColors.grayscale200
      }
    }
  };
});
export var CheckBoxGroup = function CheckBoxGroup(_ref2) {
  var checkboxGroupElements = _ref2.checkboxGroupElements,
    filterName = _ref2.filterName,
    onChange = _ref2.onChange,
    _ref2$actionButtons = _ref2.actionButtons,
    actionButtons = _ref2$actionButtons === void 0 ? [] : _ref2$actionButtons,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
  var classes = checkboxStyles();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: checkboxGroupElements === null || checkboxGroupElements === void 0 ? void 0 : _mapInstanceProperty(checkboxGroupElements).call(checkboxGroupElements, function (element, index) {
      var isDisabled = element.isDisabled || disabled;
      return /*#__PURE__*/_jsx("div", {
        className: classes.labelContainer,
        children: /*#__PURE__*/_jsx(FormControlLabel, {
          control: /*#__PURE__*/_jsx(Checkbox, {
            name: filterName,
            fontSize: 24,
            value: element.id,
            checked: element.isChecked,
            disabled: isDisabled,
            onChange: onChange,
            classes: {
              root: classes.checkbox
            },
            color: "secondary"
          }),
          label: actionButtons.length > 0 ? /*#__PURE__*/_jsxs("div", {
            style: {
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            },
            children: [typeof element.label === "string" ? /*#__PURE__*/_jsx(Typography, {
              variant: "paragraph_small",
              weight: "medium",
              style: {
                marginLeft: "16px"
              },
              color: isDisabled ? RaiseColors.grayscale900 : RaiseColors.glacier2400,
              noWrap: true,
              children: element.label
            }) : /*#__PURE__*/_jsx("div", {
              style: {
                marginLeft: "16px"
              },
              children: element.label
            }), /*#__PURE__*/_jsx("div", {
              style: {
                display: "flex",
                gap: "8px"
              },
              children: actionButtons === null || actionButtons === void 0 ? void 0 : _mapInstanceProperty(actionButtons).call(actionButtons, function (ActionButton) {
                return ActionButton(element, index);
              })
            })]
          }) : typeof element.label === "string" ? /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph_small",
            weight: "medium",
            style: {
              marginLeft: "16px"
            },
            color: isDisabled ? RaiseColors.grayscale900 : RaiseColors.glacier2400,
            noWrap: true,
            children: element.label
          }) : /*#__PURE__*/_jsx("div", {
            style: {
              marginLeft: "16px"
            },
            children: element.label
          }),
          classes: {
            root: actionButtons.length > 0 ? classes.formControlLabelActionButtons : classes.formControlLabel
          }
        })
      }, index);
    })
  });
};